module.exports = __webpack_public_path__ + "static/media/sn.b3dab1c7.svg";